var map = {
	"./gallery-1.jpg": 16871,
	"./gallery-10.jpg": 50407,
	"./gallery-11.jpg": 27754,
	"./gallery-12.jpg": 78741,
	"./gallery-2.jpg": 36888,
	"./gallery-3.jpg": 41205,
	"./gallery-4.jpg": 5582,
	"./gallery-5.jpg": 83627,
	"./gallery-6.jpg": 98972,
	"./gallery-7.jpg": 85849,
	"./gallery-8.jpg": 35010,
	"./gallery-9.jpg": 43071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91583;